import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Helper } from 'app/common/helper';
import { Constant } from 'app/config/constants';
import { CommonTable } from 'app/model/entity/commonTable';
import { CommonTableService } from 'app/service/common-table.service';
import { DialogService } from 'app/service/dialog.service';
import { DialogConfirmComponent } from '../../dialog/dialog-confirm/dialog-confirm.component';
import { Template } from '../../model/entity/template';
import { ValidationFormService } from '../../service/validation-form.service';
import { LinkDataPictureEnum, LinkDataTextEnum } from './../../config/constants';
import { UpperLimit } from './../../model/entity/upper-limit';
import { DialogMessageComponent } from '../dialog-message/dialog-message.component';

@Component({
  selector: 'app-dialog-upper-limit',
  templateUrl: './dialog-upper-limit.component.html',
  styleUrls: ['./dialog-upper-limit.component.scss']
})
export class DialogUpperLimit implements OnInit {
  /**
   * Constant
   */
  public Constant = Constant;
  /**
   * upper Limit Form
   */
  public upperLimitForm: FormGroup;
  /**
   * upper Limit
   */
  public upperLimit: UpperLimit;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogUpperLimitData,
    private commonTableService: CommonTableService,
    private dialogRef: MatDialogRef<DialogUpperLimit>,
    private formBuilder: FormBuilder,
    private validationFormService: ValidationFormService,
    private changeDetectorRef: ChangeDetectorRef,
    private translateService: TranslateService,
    private dialogService: DialogService
  ) {}

  ngOnInit(): void {
    this.upperLimit = JSON.parse(this.data.commonTable.value);
    if (!this.upperLimit.timetableId) {
      this.upperLimit.timetableId = Constant.TIMETABLE_ID_UPPER_LIMIT.DEFAULT;
    }
    this.createForm();
  }

  public createForm(): void {
    this.upperLimitForm = this.formBuilder.group({
      current: [
        this.upperLimit.current,
        [
          this.validationFormService.invalidEmpty,
          Validators.min(Constant.MIN_CURRENT_TIMETABLE),
          Validators.max(Constant.MAX_CURRENT_TIMETABLE)
        ]
      ],
      item: [
        this.upperLimit.item,
        [
          this.validationFormService.invalidEmpty,
          Validators.min(Constant.MIN_COLUMN_TIMETABLE),
          Validators.max(Constant.MAX_COLUMN_TIMETABLE)
        ]
      ],
      timetableId: [
        this.upperLimit.timetableId,
        [
          this.validationFormService.invalidEmpty,
          Validators.min(Constant.TIMETABLE_ID_UPPER_LIMIT.MIN),
          Validators.max(Constant.TIMETABLE_ID_UPPER_LIMIT.MAX)
        ]
      ]
    });
    this.changeDetectorRef.detectChanges();
  }

  /**
   * save
   * @returns
   */
  public save(): void {
    if (this.upperLimitForm.invalid) {
      return;
    }
    let upperLimitObject = new UpperLimit(
      +this.upperLimitForm.value.current,
      +this.upperLimitForm.value.item,
      +this.upperLimitForm.value.timetableId
    );
    this.data.commonTable.value = JSON.stringify(upperLimitObject);
    let currentAreas = Helper.getAllAreaTemplate(this.data.templateSelected).filter(
      area =>
        !area.isFix &&
        (area.getArea().attribute == LinkDataPictureEnum.INDEX_WORD ||
          area.getArea().linkReferenceData == LinkDataTextEnum.INDEX_WORD ||
          area.getArea().linkReferenceData == LinkDataTextEnum.TIMETABLE ||
          area.getArea().linkReferenceData == LinkDataTextEnum.OPERATION_INFO)
    );
    let isGreater = currentAreas?.some(
      current =>
        current.referencePositionRow >= upperLimitObject.current ||
        current.referenceColumn >= upperLimitObject.item ||
        (current.getArea().linkReferenceData == LinkDataTextEnum.TIMETABLE && current?.referencePositionColumn > upperLimitObject.item) ||
        ((current.getArea().attribute == LinkDataPictureEnum.INDEX_WORD ||
          current.getArea().linkReferenceData == LinkDataTextEnum.INDEX_WORD) &&
          current?.referencePositionColumn >= upperLimitObject.item)
    );

    const isGreaterTimetableId = Helper.getAllAreaTemplate(this.data.templateSelected).some(
      area => Number(area.timetableId) > upperLimitObject.timetableId
    );
    if (isGreaterTimetableId) {
      this.dialogService.showDialog(DialogMessageComponent, {
        data: {
          title: this.translateService.instant('dialog-error.title'),
          text: this.translateService.instant('dialog-upper-limit.msg.timetable-id-greater-than-value')
        }
      });
    } else if (isGreater) {
      this.dialogService.showDialog(
        DialogConfirmComponent,
        {
          data: {
            title: this.translateService.instant('dialog-confirm.title'),
            text: this.translateService.instant('dialog-upper-limit.msg.greater-than-value'),
            button1: this.translateService.instant('dialog-confirm.timetable-operation-manager.button-1'),
            button2: this.translateService.instant('dialog-confirm.timetable-operation-manager.button-2')
          }
        },
        result => {
          if (result) {
            this.commonTableService.save(this.data.commonTable).subscribe(
              () => {
                this.dialogRef.close([true, this.data.commonTable.value]);
              },
              error => Helper.handleError(error, this.translateService, this.dialogService)
            );
          } else {
            this.dialogRef.close();
          }
        }
      );
    } else {
      this.commonTableService.save(this.data.commonTable).subscribe(
        () => {
          this.dialogRef.close([false, this.data.commonTable.value]);
        },
        error => Helper.handleError(error, this.translateService, this.dialogService)
      );
    }
  }

  /**
   * cancel
   */
  public cancel(): void {
    this.dialogRef.close(undefined);
  }
}
export interface DialogUpperLimitData {
  commonTable: CommonTable;
  templateSelected: Template;
}
